import { PassengerFare } from "./AdvCalendarSearchPropertise";
import { BookingInfoProperties } from "./BookingPassengerTicketIssuanceProperties";
import { FlightSearchAirports, FlightSearchProperties } from "./FlightSearchProperties";
import {  CombinationOfSubBrands, PassengerFares } from "./FlightSearchResponseProperties";

export class FilterFlightResultBinding {
  stopsDetails: StopFlightFilters;
  stopsDetailsReturn: StopFlightFilters;
  fareType: FaretypeFilters;
  priceFilterMin: number = 0;
  priceFilterMax: number = 0;
  airlinesList: FilterByAirlineProperties[];
  applyMarkup: number = 0;
  timeList: TimeListFilter;
  stopIsChecked: boolean = false;
  airlineIsChecked: boolean = false;
  fareTypeIsChecked: boolean = false;
  timeIsChecked: boolean = false;
  markupIsChecked: boolean = false;
}
export class TimeListFilter {
  morningChecked: boolean = false;
  afternoonChecked: boolean = false;
  eveningChecked: boolean = false;
  nightChecked: boolean = false;
}
export class FaretypeFilters {
  refundableCountFlights: number = 0;
  nonRefundableCountFlights: number = 0;
  refundableFlightschecked: boolean = false;
  nonRefundableFlightschecked: boolean = false;
}
export class StopFlightFilters {
  directFlights: number = 0;
  directFlightsMin: number = 0;
  directchecked: boolean = false;
  returnDirectFlights: number = 0;
  oneStopFlights: number = 0;
  oneStopFlightsMin: number = 0;
  onestopchecked: boolean = false;
  returnOneStopFlights: number = 0;
  twoStopPlusFlights: number = 0;
  twoStopPlusFlightsMin: number = 0;
  returnTwoStopFlights: number = 0;
  twoplusstopchecked: boolean = false;
}
export class FilterByAirlineProperties {
  airlineLogo: string = "";
  airlineName: string = "";
  airlineLowestPrice: number = 0;
  airlineHighestPrice: number = 0;
  airlineChecked: boolean = false;
}
export class FlightSearchNewResponseProperties {
  flights: FlightSchedulesNew[];
  error: string;
  fareChanged: FareChangedProperties;
  isFareChanged: boolean = false;

}
export class FareChangedProperties {
  priceFront: number = 0;
  priceServer: number = 0;
  currency: string = "";
}
export class MulticityResponseFlightsNew {
  allMultiFlights: FlightSchedulesNew[];
  departureDate: string;
  error: string;
  fareChanged: FareChangedProperties;
  isFareChanged: boolean = false;
  currencyRate: number = 0;
}

export class FlightSchedulesNew {
  isSpecialFare: boolean;
  promoCode: string;
  currencyRateByDefault: number;
  currencyCriteriaThatApplied: string;
  revenueApplied: string;
  rbdSegments: RBDSegments[]=[];
  multicityBrands: CombinationOfSubBrands[] = [];
  combinationOfBrands: BrandsNew[][] = [];
  departureFlight: BaseNewFlightDetails;
  returnFlight: BaseNewFlightDetails;
  multiFlights: BaseNewFlightDetails[];
  frontBaggageAllowance: FrontBaggageAllowanceType[];
  airSegmentsNew: AirSegmentsDetailsNew[];
  frontFareRules: FrontFareRules[][];
  fareRules: any;
  //-------------------this allBrandsForAllSectorCheck is used for when all the sector have only one selection like hitit----------------
  allBrandsForAllSectorCheck: boolean = false;
  //---------------------------------------------------------------end ------------------------------------------------------------------
  bySectorBrands: BySectorBrands[];
  brands: BrandsNew[];
  MulticityBrands: BrandsNew[];
  returnBrands: BrandsNew[];
  passengerFares: PassengerFares[];
  supplierPricingSolution: string;
  transactionIdentifier: string;
  frontReusePricingSolution: any;
  combinationBrandsAvailiable: boolean = false;
  changeBookingAvailiable: boolean = false;
  repriceAvailiable: boolean = false;
  changeRBDAvailiable: boolean = false;
  brandsAvailiable: boolean = false;
  fromAirport: any;
  fareRulesAvailiable: boolean = false;
  baggageAvailiable: boolean = false;
  toAirport: any;
  seatsAvailiable: boolean = false;
  fareRulesAfterShowAvailiable: boolean = false;
  fareRulesNew = new FareRulesNew();
  groupTitle: string = "";
  groupImageFile: string = "";
  totalNumberTicket: number;
  remainingTickets: number;
  isAdult: boolean = false;
  isChild: boolean = false;
  isInfant: boolean = false;
    
    baggageDetails: string;
  seatMap: string;
  fareOnCall: boolean = false;
}


export class BaseNewFlightDetails {
  departureDate: string;
  nonRefundable  :boolean = false;
  supplier: string;
  arrival: ArrivalNew;
  departure: DepartureNew;
  marketingFlight: string;
  marketingFlightNumber: number;
  airline: string;
  airlineLegalName: string;
  airlineLogo: string;
  operating: string;
  stopCount: number;
  totalPrice: string;
  totalTaxAmount: string;
  baseFareAmount: string;
  agencyTotalPrice: string;
  agencyTaxAmount: string;
  agencyBaseFareAmount: string;
  baseFareCurrency: string;
  discountedFare?: number;
  elapsedTime: string;
  smokingAllowed  :boolean = false;
  seatsPending: string;
  fareBasis: string;
  cabinClass: string;
  pcc: string;
  vat: string;
  rbd: string;
  groupTicketObj: GroupTicketBaseFlightProperties;
  groupTicketId: number=0;
  groupTicketSupplierCode: string;
  groupTicketPNR: string;
    groupTicketSupplierRemarks: string;
}

export class GroupTicketBaseFlightProperties {
  groupTicketId: number;
  groupTicketPNR: string;
  groupTicketSupplierCode: string;
  groupTicketSupplierRemarks: string;
}

export class DepartureNew {
  airport: string;
  city: string;
  country: string;
  terminal: string;
  time: string;
  date: string;
  orignalDate: Date;
  depEquipment: string;
  flightNumber: string;
}

export class ArrivalNew {
  airport: string;
  city: string;
  flightNo: string;
  country: string;
  terminal: string;
  time: string;
  arivEquipment: string;
  flightNumber: string;
  orignalDate: Date;
  date: string;
  dateAdjustment: number;
}

export class BySectorBrands {
  brandsList: BrandsNew[];
  fromAirport: string;
  toAirport: string;
  supplierPricingSolution: string;
  selectedbrand: string;
  brandId: number = 0;
  brandsindex: boolean = false;
  priceofselectedbrand: number;
  passengerFares: PassengerFares[] = [];
}
export class flightsectorIndex {
  prevflight: number = 0;
  prevsector: number = 0;
  prevbrand: number = 0;
}
export class AirSegmentsDetailsNew {
  layoverTime: string;
  layoverAvailable: boolean = false;
  originalDepartureDate: Date;
  originalArrivalDate: Date;
  origin: AirportDetailsNew;
  destination: AirportDetailsNew;
  departureTime: string;
  arrivalDate: string;
  departureDate: string;
  arrivalTime: string;
  carrier: string;
  flightNumber: string;
  flightTime: string;
  connectionTime: string;
  connectionTimeAvailable  :boolean = false;
  classOfService: string;
  cabinClass: string;
  operatingAirline: string;
  flightLegalName: string;
  flightLogo: string;
  equipment: string="";
  sector: any;
  index: number;
  baggageCheckin: string;
  baggageCabin: string;
  airlineCombineCode: string;
  meal: string;
  flightStatus: string;

  baggageProvisionType: string;
}

export class AirportDetailsNew {
  code: string;
  airportName: string;
  terminal: string;
}


export class RBDSegments {
  origin: string;
  destination: string;
  rbdList: string[];
  selectedRBD: string;
}
export class BrandsNew {
  departureDate: string="";
  arrivalDate: string = "";
  brandName: string = "";
  brandID: number=0;
  solnId: number = 0;
  baggageCheckIn: string = "";
  rBD: string = "";
  text: string = "";
  meal: boolean=false;
  seat: boolean = false;
  carrier: string = "";
  baggageCabin: string = "";
  skywardMiles: number = 0;
  upgradeToBusiness: number = 0;
  passengerFares: PassengerFares[];
  farePenalties: FrontFareRules[];
  supplierPricingSolution: string = "";
  changeFee: string[]=[];
  refundFee: string[]=[];
  brandPrice: number = 0;
  fareRules = new FareRulesNew();
  frontBagList: FrontBaggageAllowanceType[];
}
export class FrontFareRules {
  passengerType: string;
  changeFeePenalty: ChangeFee[];
  cancellationFeePenalty: CancellationFee[];
  faresRulesAreStatic  :boolean = false;
  fareRulesStaticString: string;
}

export class ChangeFee {
  typeChangeFee: string;
  percentageChangeFee: number;
  penaltyType: string;
  amount: string;
  currency: string;
  fareRulesString: string;
  generalRulesString: string;
}

export class CancellationFee {
  typeChangeFee: string;
  percentageChangeFee: number;
  penaltyType: string;
  amount: string;
  currency: string;
  fareRulesString: string;
  generalRulesString: string;
}
export class AgencyWiseFareCalculations {
  agency_BranchId: string;
  serviceFee: number;
  discount: number;
  markup: number;
  airlineCommisionType: string;
  airlineCommision: number;
  airlineCommissionPercentage: string;
  commissionType: CommissionType;
  airlineCommisionRevenueId: number;
  discountValue: number;
  markupValue: number;
  serviceFeeValue: number;
  airlineCommisionValue: number;
  commissionOffer: number;
  commissionOfferValue: number;
}

export enum CommissionType {
  baseFare = 1,
  totalFare = 2
}
export class FrontBaggageAllowanceType {
  passengerType: string;
  sector: string;
  cabinBaggage: string;
  checkinBaggage: string;
  baggageNote: string;
}
export class ChangeCancelPenalty {
  penaltyType: string;
  penaltyAmount: number;
  penaltyPercentage: number;
  currency: string;
}
export class PassengerWiseFareRules {
  passengerType: string;
  changePenalty: ChangeCancelPenalty[] = [];
  cancelPenalty: ChangeCancelPenalty[] = [];

}
export class SectorWiseFareRules {
  origin: string
  destination: string
  passengerWiseFareRules: PassengerWiseFareRules[] = [];
  fareRulesLong: string[] = [];
  fareRulesLongAvailable: boolean;
  cancelPenaltyAvailable: boolean;
  changePenaltyAvailable: boolean;
}
export class FareRulesNew {
  fareRulesStaticStringAvailable: boolean;
  fareRulesStaticString: string;
  sectorWiseFareRules: SectorWiseFareRules[] = [];
  generalRules: string[] = [];
  generalRulesAvailable: boolean;
    supplier: string;
}
export class RBDBaggageSelection {
  sector: string;
  baggageDet: string;
  desc2: string;
}
export class RBDChargeSelection {
  paxType: string;
  basePrice: string;
  taxes: string;
  serviceCharges: string;
  discount: string;
  total: string;
}
export class RBDPaneltyCharges {
  paxType: string;
  cancel: string;
  change: string;
}
